import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  root: {
    height: 9,
  },
  colorPrimary: {
    backgroundColor: 'WhiteSmoke',
  },
  barColorPrimary: {
    backgroundColor: 'DarkGray',
  },
});
